var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImmersiveWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.949 174.974C134.604 174.974 131.247 174.883 127.902 175C123.477 175.156 120.016 173.334 117.205 170.106C116.255 169.026 115.448 167.802 114.641 166.605C107.743 156.335 92.2567 156.348 85.3593 166.605C84.2401 168.258 83.0298 169.885 81.6242 171.304C79.1255 173.816 76.0542 175.039 72.4363 175C65.682 174.922 58.9407 175 52.1865 174.974C36.8038 174.922 25.0521 163.168 25.0001 147.822C25.0001 142.629 24.9741 137.448 25.0001 132.255C25.0652 117.208 36.8429 105.363 51.8741 105.337C83.9538 105.298 116.033 105.298 148.113 105.337C163.144 105.35 174.909 117.195 174.974 132.268C175 137.513 175 142.759 174.974 148.004C174.909 163.142 163.131 174.909 147.97 174.974C144.625 174.987 141.281 174.974 137.923 174.974H137.949ZM140.994 116.049C139.159 116.049 137.311 116.049 135.476 116.049C133.368 116.062 132.145 117.065 132.158 118.731C132.158 120.397 133.381 121.399 135.489 121.399C138.782 121.399 142.075 121.373 145.354 121.399C152.811 121.464 158.485 126.892 158.902 134.324C159.019 136.329 160.021 137.474 161.622 137.461C163.3 137.435 164.29 136.16 164.25 134.09C164.081 126.84 159.214 120.045 152.369 117.338C148.673 115.88 144.834 116.01 140.994 116.036V116.049ZM161.648 142.85C160.19 142.824 158.967 144.008 158.928 145.453C158.902 146.898 160.086 148.148 161.531 148.174C162.975 148.2 164.224 147.015 164.25 145.557C164.277 144.113 163.092 142.863 161.635 142.837L161.648 142.85Z",
    fill: "url(#paint0_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1338 59.3244C61.1791 41.8175 76.6268 28.2414 91.0724 26.0938C89.797 29.9726 88.2483 33.8905 87.2462 37.9516C86.1921 42.2079 85.5935 46.5814 84.9688 50.9289C84.7736 52.2826 84.253 52.634 82.9906 52.7772C75.95 53.5452 69.0135 54.8338 62.3764 57.437C60.9839 57.9837 59.6434 58.6475 58.1338 59.3244Z",
    fill: "url(#paint1_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.009 59.4282C133.784 55.289 125.338 53.688 116.71 52.7638C115.318 52.6206 115.174 51.8917 115.057 50.7983C114.263 43.7435 112.988 36.7928 110.372 30.1675C109.839 28.8268 109.201 27.5252 108.602 26.2105C111.934 25.7029 121.707 30.1545 127.303 34.8403C134.956 41.2444 139.823 49.3275 142.009 59.4412V59.4282Z",
    fill: "url(#paint2_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5237 78.2886V57.3584H110.463V78.2886H89.5237Z",
    fill: "url(#paint3_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1989 76.3232C66.1635 80.3453 74.5706 81.9072 83.1208 82.9095C84.0839 83.0266 84.7216 83.1698 84.9168 84.3803C85.7367 89.3786 86.6737 94.3508 87.5716 99.3361C87.5977 99.4923 87.5716 99.6615 87.5716 99.9739C82.4181 99.9739 77.3035 99.9739 72.189 99.9479C71.8116 99.9479 71.3822 99.6355 71.0698 99.3491C64.4587 93.2965 60.2291 85.8512 58.1989 77.1433C58.1469 76.935 58.1989 76.7137 58.1989 76.3363V76.3232Z",
    fill: "url(#paint4_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.389 99.9742C113.014 96.8633 113.665 93.8825 114.211 90.8888C114.576 88.8582 114.901 86.8147 115.044 84.7711C115.148 83.4174 115.695 83.0269 116.983 82.8838C124.31 82.0898 131.52 80.7621 138.378 77.9115C139.498 77.4429 140.591 76.9093 142.087 76.2324C141.411 78.4973 140.903 80.4757 140.226 82.3891C137.936 88.8713 134.214 94.4162 129.204 99.1021C128.787 99.4926 128.201 99.9351 127.681 99.9351C122.618 100 117.543 99.9742 112.402 99.9742H112.389Z",
    fill: "url(#paint5_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.916 77.7424V57.6973C120.797 58.6865 125.638 59.4284 130.336 60.704C133.628 61.5891 136.882 62.9298 139.901 64.5569C143.857 66.6915 143.779 68.8522 139.901 71.1952C134.956 74.1759 129.412 75.4906 123.816 76.5319C121.213 77.0265 118.571 77.3519 115.916 77.7554V77.7424Z",
    fill: "url(#paint6_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.865 51.905H90.1094C90.4998 49.3147 90.695 46.6594 91.3327 44.1212C92.504 39.5525 93.8704 35.0228 95.315 30.5322C95.7445 29.1915 96.6034 27.9289 97.4623 26.7835C99.2583 24.3755 100.781 24.4276 102.616 26.8486C103.149 27.5515 103.631 28.3194 104.034 29.1134C107.613 36.2594 108.889 43.9911 109.865 51.905Z",
    fill: "url(#paint7_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0837 77.8206C80.3097 77.1567 76.5486 76.7402 72.9177 75.777C68.9614 74.7227 65.0962 73.2518 61.2571 71.781C60.0598 71.3254 59.0057 70.3622 58.0166 69.4771C56.8583 68.4488 56.8974 67.2383 58.0036 66.1319C58.5111 65.6243 59.0577 65.1166 59.6694 64.7522C67.1785 60.2485 75.5986 59.0901 84.0837 57.9316V77.8076V77.8206Z",
    fill: "url(#paint8_linear_121_60101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 99.9221H93.0114C91.9833 94.5724 90.9682 89.2097 89.9141 83.7559H110.073C109.032 89.2097 108.017 94.5854 106.989 99.9221H107.002Z",
    fill: "url(#paint9_linear_121_60101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60101",
    x1: 99.9911,
    y1: 105.308,
    x2: 99.9911,
    y2: 175.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60101",
    x1: 74.6031,
    y1: 26.0937,
    x2: 74.6031,
    y2: 59.3244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60101",
    x1: 125.306,
    y1: 26.1709,
    x2: 125.306,
    y2: 59.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_60101",
    x1: 99.9935,
    y1: 57.3584,
    x2: 99.9935,
    y2: 78.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_60101",
    x1: 72.8795,
    y1: 76.3232,
    x2: 72.8795,
    y2: 99.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_60101",
    x1: 127.238,
    y1: 76.2324,
    x2: 127.238,
    y2: 99.9793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_60101",
    x1: 129.378,
    y1: 57.6973,
    x2: 129.378,
    y2: 77.7554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_60101",
    x1: 99.987,
    y1: 25.0049,
    x2: 99.987,
    y2: 51.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_60101",
    x1: 70.6223,
    y1: 57.9316,
    x2: 70.6223,
    y2: 77.8206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_121_60101",
    x1: 99.9934,
    y1: 83.7559,
    x2: 99.9934,
    y2: 99.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmersiveWorld);
export default __webpack_public_path__ + "static/media/Immersive_World.cff0c2448466f78c96246c0da1016b7d.svg";
export { ForwardRef as ReactComponent };